import React from "react";
import { useTheme } from "styled-components";

const Pages = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.188 6.75a.563.563 0 0 1 .562-.562h4.5a.562.562 0 1 1 0 1.125h-4.5a.563.563 0 0 1-.562-.563m.562 2.813h4.5a.562.562 0 1 0 0-1.126h-4.5a.563.563 0 1 0 0 1.126M9 10.687H6.75a.563.563 0 0 0 0 1.126H9a.563.563 0 0 0 0-1.126m6.75-7.312v7.642a1.12 1.12 0 0 1-.33.796l-3.607 3.607a1.12 1.12 0 0 1-.796.33H3.375a1.125 1.125 0 0 1-1.125-1.125V3.375A1.125 1.125 0 0 1 3.375 2.25h11.25a1.125 1.125 0 0 1 1.125 1.125M3.375 14.625h7.313V11.25a.56.56 0 0 1 .562-.562h3.375V3.375H3.375zm8.438-2.812v2.018l2.017-2.018z"
        fill={theme.text.text}
      />
    </svg>
  );
};

export default Pages;
